import React from "react";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import SaveIcon from "@material-ui/icons/SaveAlt";
import { LastPage, FileCopy } from "@material-ui/icons";
import {
  PopupMessage,
  SecuredMenuFunctionalButton,
  SecuredMenuLinkButton
} from "lego-gui-lib/lib";
import { mainStore } from "../../../core/mainStore";
import { inject } from "mobx-react";
import { SecuredEditButton } from "lego-gui-lib/lib/components/Buttons/SecuredEditButton";
import { t } from "../../../core/i18n/i18n";
import { RowButton } from "../../../common/RowButtons";

export const customRowButtons = (indexProps: any) => (
  row: any,
  key: string,
  close: () => void
) => {
  const arr = [];
  const commons = mainStore.commons;
  const totalRows = indexProps.props.dataSource.total as number;
  const onDelete = (e: any) => {
    indexProps.callbackDelete(row);
    close();
  };

  const dialogMessage: PopupMessage = {
    title: t("hns:huntingGroupMember:move.popupTitle", {
      position: row.position
    })()
  };

  const EditButton = inject("i18n")(({ i18n: i18n, ...props }) => {
    const title = i18n.t("lego:views.index.row.edit", "Edit");
    return <SecuredEditButton title={title} {...props} />;
  });

  const onExport = (e: any) => {
    indexProps.props.dataSource.exportSelected("text/csv", row);
    close();
  };

  const move = (destination: any) => () => {
    indexProps.props.dataSource.moveRow(row, { moveTo: destination });
    commons.closeDialog();
    close();
  };

  const first = () => {
    dialogMessage.content = t(
      "hns:huntingGroupMember:move.toFirstPlace.popupMessage"
    )();
    commons.showDialog(dialogMessage, move(0));
  };

  const last = () => {
    dialogMessage.content = t(
      "hns:huntingGroupMember:move.toLastPlace.popupMessage",
      { position: totalRows - 1 }
    )();
    commons.showDialog(dialogMessage, move(totalRows - 1));
  };

  arr.push(
    <EditButton link={indexProps.props.columns.link(row)} key={key + "edit"} />
  );

  arr.push(
    <RowButton
      link={"/create" + indexProps.props.columns.link(row)}
      title={["lego:views.index.row.copy", "Copy"]}
      requiredAccess={"editable"}
      key={key + "copy"}
    >
      <FileCopy />
    </RowButton>
  );

  arr.push(
    <RowButton
      callbackFunction={onDelete}
      title={["lego:views.index.row.delete", "Delete"]}
      key={key + "delete"}
    >
      <DeleteIcon />
    </RowButton>
  );

  arr.push(
    <RowButton
      callbackFunction={onExport}
      title={["lego:views.index.row.export", "Export"]}
      key={key + "export"}
    >
      <SaveIcon />
    </RowButton>
  );

  if (row.position > 0) {
    arr.push(
      <RowButton
        callbackFunction={first}
        title={[
          "hns:huntingGroupMember:move.toFirstPlace.buttonTitle",
          "Move to first place"
        ]}
        key={key + "first"}
      >
        <LastPage style={{ transform: "rotate(270deg)" }} />
      </RowButton>
    );
  }
  if (row.position < totalRows - 1) {
    arr.push(
      <RowButton
        callbackFunction={last}
        title={[
          "hns:huntingGroupMember:move.toLastPlace.buttonTitle",
          "Move to last place"
        ]}
        key={key + "last"}
      >
        <LastPage style={{ transform: "rotate(90deg)" }} />
      </RowButton>
    );
  }
  return arr;
};
